// Bilingual content for Abdulrahman Al-Hadi Media Kit (mock data)

export const PROFILE_LINK = "https://www.tiktok.com/@id7oom911";
export const PROFILE_IMG =
  "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/cdli4706_IMG_3947.jpeg";
export const TIKTOK_LOGO =
  "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/04rkdodg_IMG_5739.jpeg";
export const WHATSAPP = "966506883553";
export const EMAIL = "id7oom911@hotmail.com";

export const content = {
  ar: {
    dir: "rtl",
    langLabel: "EN",
    nav: {
      home: "الرئيسية",
      platforms: "المنصات",
      features: "مميزات الإعلان",
      demographics: "الجمهور",
      brands: "الشركاء",
      testimonials: "شهادات العملاء",
      cta: "تواصل معي",
    },
    hero: {
      badge: "موثوق",
      certified: "معتمد",
      name: "عبدالرحمن الهادي",
      subtitle:
        "مؤثر وخبير تقني، أمتلك حضورًا واسعًا وتأثيرًا قويًا عبر منصات التواصل الاجتماعي، وأساعد العلامات التجارية على الوصول إلى جمهورها.",
      tags: ["تطبيقات", "أجهزة", "مؤتمرات", "مواقع", "أنظمة"],
      ctaPrimary: "احجز حملتك الإعلانية",
      ctaSecondary: "استكشف الإحصائيات",
      stats: [
        { value: "+750 ألف", label: "إجمالي المتابعين", color: "blue" },
        { value: "+8 مليون", label: "أعلى مشاهدات فيديو", color: "red" },
        { value: "4", label: "منصات نشطة", color: "green" },
        { value: "98%", label: "نسبة النجاح", color: "gold" },
      ],
    },
    platforms: {
      overline: "حضور رقمي",
      title: "المنصات الاجتماعية",
      subtitle: "انقر على أي منصة لزيارة الحساب الرسمي",
    },
    features: {
      overline: "لماذا تعلن معي",
      title: "مميزات الإعلان",
      subtitle: "باقة متكاملة تضمن أعلى وصول وأطول مدة ظهور لإعلانك",
    },
    demographics: {
      overline: "تحليلات الجمهور",
      title: "بيانات الجمهور",
      subtitle: "جمهور حقيقي ومتفاعل يتركز في الخليج العربي",
      genderTitle: "توزيع الجنس",
      ageTitle: "الفئات العمرية",
      countriesTitle: "أكثر الدول",
      citiesTitle: "أكثر المدن",
      male: "ذكور",
      female: "إناث",
    },
    testimonials: {
      overline: "قالوا عنّا",
      title: "شهادات العملاء",
      subtitle: "نتائج حقيقية حققها شركاؤنا من الحملات الإعلانية",
    },
    brands: {
      overline: "شركاء النجاح",
      title: "شراكات وعلامات تجارية",
      subtitle: "من الشركات والتطبيقات التي وثقت بنا وحققت نتائج ملموسة",
    },
    footer: {
      tagline: "مؤثر تقني معتمد — المملكة العربية السعودية",
      licenseAuthority: "الهيئة العامة لتنظيم الإعلام",
      licenseNumber: "رقم الترخيص: 155967",
      licenseValid: "صالح حتى 2027/12/04",
      contactTitle: "تواصل معي",
      rights: "© 2025 عبدالرحمن الهادي. جميع الحقوق محفوظة.",
      quickLinks: "روابط سريعة",
    },
    contact: { whatsapp: "واتساب", email: "البريد الإلكتروني", pdf: "تحميل PDF" },
  },
  en: {
    dir: "ltr",
    langLabel: "ع",
    nav: {
      home: "Home",
      platforms: "Platforms",
      features: "Ad Features",
      demographics: "Audience",
      brands: "Partners",
      testimonials: "Testimonials",
      cta: "Contact Me",
    },
    hero: {
      badge: "Trusted",
      certified: "Certified",
      name: "Abdulrahman Al-Hadi",
      subtitle:
        "Influencer and Tech Expert with a wide presence and strong impact across social media platforms, helping brands reach their audiences.",
      tags: ["Apps", "Devices", "Conferences", "Websites", "Systems"],
      ctaPrimary: "Book Your Campaign",
      ctaSecondary: "Explore Stats",
      stats: [
        { value: "+750K", label: "Total Followers", color: "blue" },
        { value: "+8M", label: "Top Video Views", color: "red" },
        { value: "4", label: "Active Platforms", color: "green" },
        { value: "98%", label: "Success Rate", color: "gold" },
      ],
    },
    platforms: {
      overline: "Digital Presence",
      title: "Social Platforms",
      subtitle: "Click any platform to visit the official account",
    },
    features: {
      overline: "Why Advertise With Me",
      title: "Advertising Features",
      subtitle: "A complete package ensuring maximum reach and longest exposure",
    },
    demographics: {
      overline: "Audience Analytics",
      title: "Audience Data",
      subtitle: "A real, engaged audience concentrated in the Arabian Gulf",
      genderTitle: "Gender Distribution",
      ageTitle: "Age Groups",
      countriesTitle: "Top Countries",
      citiesTitle: "Top Cities",
      male: "Male",
      female: "Female",
    },
    testimonials: {
      overline: "What They Say",
      title: "Client Testimonials",
      subtitle: "Real results achieved by our partners from ad campaigns",
    },
    brands: {
      overline: "Trusted Partners",
      title: "Brands & Partnerships",
      subtitle: "Companies and apps that trusted us and achieved tangible results",
    },
    footer: {
      tagline: "Certified Technical Influencer — Saudi Arabia",
      licenseAuthority: "General Authority for Media Regulation",
      licenseNumber: "License No: 155967",
      licenseValid: "Valid until 2027/12/04",
      contactTitle: "Contact Me",
      rights: "© 2025 Abdulrahman Al-Hadi. All rights reserved.",
      quickLinks: "Quick Links",
    },
    contact: { whatsapp: "WhatsApp", email: "Email", pdf: "Download PDF" },
  },
};

export const platforms = [
  {
    id: "tiktok",
    name: { ar: "تيك توك", en: "TikTok" },
    metric: { ar: "متابع", en: "Followers" },
    count: "550K+",
    url: "https://www.tiktok.com/@id7oom911",
    handle: "@iD7oom911",
    brand: "#000000",
    accent: "#25F4EE",
    logoImg: TIKTOK_LOGO,
  },
  {
    id: "x",
    name: { ar: "منصة X", en: "X (Twitter)" },
    metric: { ar: "متابع", en: "Followers" },
    count: "+119,000",
    url: "https://x.com/iD7oom911",
    handle: "@iD7oom911",
    brand: "#000000",
    accent: "#1DA1F2",
  },
  {
    id: "snapchat",
    name: { ar: "سناب شات", en: "Snapchat" },
    metric: { ar: "مشاهدة", en: "Views" },
    count: "75K+",
    url: "https://www.snapchat.com/add/iD7oom911hd",
    handle: "@iD7oom911hd",
    brand: "#FFFC00",
    accent: "#FFFC00",
  },
  {
    id: "telegram",
    name: { ar: "تليجرام", en: "Telegram" },
    metric: { ar: "مشترك", en: "Subscribers" },
    count: "+12,000",
    url: "https://t.me/iD7oom911",
    handle: "@iD7oom911",
    brand: "#229ED9",
    accent: "#229ED9",
  },
];

export const features = [
  {
    id: "reach",
    icon: "Globe2",
    color: "#2563EB",
    title: { ar: "انتشار واسع", en: "Wide Reach" },
    desc: {
      ar: "يتم نشر الإعلان على جميع الحسابات في المنصات المذكورة لتحقيق انتشار واسع في الوقت ذاته.",
      en: "The ad is published on all accounts across the mentioned platforms to achieve wide reach simultaneously.",
    },
  },
  {
    id: "pin",
    icon: "Pin",
    color: "#0EA5E9",
    title: { ar: "تثبيت الإعلان", en: "Ad Pinning" },
    desc: {
      ar: "يتم تثبيت الإعلان لمدة أسبوع في تيك توك واكس وتليجرام وسناب شات لضمان مشاهدات أعلى وتفاعل أكثر.",
      en: "The ad is pinned for a week on TikTok, X, Telegram, and Snapchat to ensure higher views and more engagement.",
    },
  },
  {
    id: "links",
    icon: "Link2",
    color: "#7C3AED",
    title: { ar: "صفحة الروابط", en: "Links Page" },
    desc: {
      ar: "وضع رابط الإعلان في صفحة الروابط لمدة شهر لسهولة الوصول إليه وزيادة التنزيلات والزيارات.",
      en: "Placing the ad link on the links page for one month for easy access and to increase downloads and visits.",
    },
  },
  {
    id: "longterm",
    icon: "CalendarClock",
    color: "#D4AF37",
    title: { ar: "محتوى طويل الأمد", en: "Long-Term Content" },
    desc: {
      ar: "الفيديو الإعلاني يبقى في جميع الحسابات لمدة عام كامل ولا يتم حذفه لضمان استمرارية الظهور.",
      en: "The ad video stays on all accounts for a full year and is not deleted to ensure continuous visibility.",
    },
  },
  {
    id: "repost",
    icon: "Repeat2",
    color: "#059669",
    title: { ar: "ريبوست مجاني", en: "Free Repost" },
    desc: {
      ar: "عمل ريبوست لأحد منشورات المعلن في تيك توك ويبقى في قائمة الريبوست لمدة شهر كامل.",
      en: "A repost of one of the advertiser's posts on TikTok, kept in the repost list for a full month.",
    },
  },
  {
    id: "license",
    icon: "ShieldCheck",
    color: "#DB2777",
    title: { ar: "كود ترخيص الإعلان", en: "Ad License Code" },
    desc: {
      ar: "توفير كود ترخيص رسمي للإعلان في تيك توك بمدة تتراوح من أسبوع إلى سنة كاملة.",
      en: "An official TikTok ad license code provided for a period ranging from one week up to a full year.",
    },
  },
];

export const demographics = {
  gender: { male: 63, female: 37 },
  ages: [
    { range: "25 - 34", value: 44 },
    { range: "18 - 24", value: 24 },
    { range: "35 - 44", value: 20 },
    { range: "45 - 55", value: 8 },
  ],
  countries: [
    { ar: "السعودية", en: "Saudi Arabia", flag: "🇸🇦", value: 81 },
    { ar: "العراق", en: "Iraq", flag: "🇮🇶", value: 4 },
    { ar: "الكويت", en: "Kuwait", flag: "🇰🇼", value: 2.7 },
  ],
  cities: [
    { ar: "الرياض", en: "Riyadh", value: 41 },
    { ar: "جدة", en: "Jeddah", value: 38 },
    { ar: "المنطقة الشرقية", en: "Eastern Province", value: 9 },
  ],
};

export const testimonials = [
  {
    id: "tecno",
    client: { ar: "شركة تكنو", en: "TECNO" },
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_eec1f2f3-3e53-4a57-b612-af8a01399719/artifacts/25fp8wq1_IMG_8860.webp",
    text: {
      ar: "نشكر الأستاذ عبدالرحمن الهادي على إعلانه الإبداعي لجهازنا وتغطيته الاحترافية لمؤتمرنا.",
      en: "We thank Mr. Abdulrahman Al-Hadi for his creative ad for our device and his professional coverage of our conference.",
    },
    badge: { ar: "تغطية مؤتمر احترافية", en: "Pro Conference Coverage" },
  },
  {
    id: "siras",
    client: { ar: "تطبيق سيراس", en: "Siras App" },
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_eec1f2f3-3e53-4a57-b612-af8a01399719/artifacts/6nkt71sj_IMG_8859.jpeg",
    text: {
      ar: "إعلان عظيم وجبار بمعنى الكلمة، الله يوفقك ويسعدك ويبيّض وجهك. وسيكون تعاملنا معكم بشكل شهري بإذن الله.",
      en: "A truly great and powerful ad — may God grant you success, happiness, and pride. Our collaboration will now be monthly, God willing.",
    },
    badge: { ar: "شراكة شهرية", en: "Monthly Partnership" },
  },
  {
    id: "manchester",
    client: { ar: "معهد مانشستر — ماليزيا", en: "Manchester Institute — Malaysia" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/aahiwlvu_IMG_5883.jpeg",
    text: {
      ar: "الإعلان اللي سويناه معك كان ضربة نجاح بكل معنى الكلمة بفضل الله أولاً، ثم ثقة جمهورك فيك، وصلت الأرباح لأكثر من 120 ألف ريال. جمهورك ما يخذل وصوتك دايم يصنع الفرق.",
      en: "The ad we did with you was a success in every sense of the word — thanks to God first, then the trust of your audience. Profits reached over 120,000 SAR. Your audience never disappoints and your voice always makes a difference.",
    },
    badge: { ar: "+120,000 ريال", en: "+120,000 SAR" },
  },
  {
    id: "savior",
    client: { ar: "تطبيق Savior", en: "Savior App" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/v5hxkwvq_IMG_5934.jpeg",
    text: {
      ar: "يعطيك العافية أخوي عبدالرحمن على الإعلان، بعد الإعلان حقك ما شاء الله تبارك الله صار ضغط قوي على التطبيق.",
      en: "Thank you, brother Abdulrahman, for the ad. After your ad — mashallah — there was strong traffic pressure on the app.",
    },
    badge: { ar: "ضغط قوي على التطبيق", en: "Strong App Traffic" },
  },
  {
    id: "mobileshop",
    client: { ar: "موبايل شوب تليكوم", en: "Mobile Shop Telecom" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/8v3uoa4x_IMG_5928.jpeg",
    text: {
      ar: "الله يبيّض وجهك ويعلمك، بصراحة جاني ناس كثير من طرفك. ألف شكر لك ونتمنى تواصل على خير.",
      en: "May God reward you. Honestly, many people came to me through you. A thousand thanks, and we look forward to more.",
    },
    badge: { ar: "زيادة كبيرة في العملاء", en: "Major Customer Growth" },
  },
  {
    id: "gold",
    client: { ar: "تطبيق أسعار الذهب", en: "Gold Prices App" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/egv0o16v_SIX_83AD4AC3-17EA-4ADD-9A5B-88393AA108A3.webp",
    text: {
      ar: "تصميم الفيديو فوق الممتاز وطريقة الشرح فوق الممتاز، تجربة التعامل مع الأستاذ عبدالرحمن الهادي تجربة ممتازة وقمنا بالرجوع إليه وعمل إعلان مرة ثانية.",
      en: "The video design was outstanding and the explanation excellent. Working with Mr. Abdulrahman Al-Hadi was a great experience — we returned to him for a second ad.",
    },
    badge: { ar: "عميل راجع — إعلان 3 مرات", en: "Returning Client — 3 Times" },
  },
  {
    id: "emergent",
    client: { ar: "منصة Emergent AI", en: "Emergent AI" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/eyz9fa3x_IMG_5936.jpeg",
    text: {
      ar: "طلبنا منه الوصول لرقم معين من الاشتراكات خلال أسبوع، ولكن تم الوصول له في أول 10 ساعات. كنا نعتقد أنه مشهور لكن اتضح لنا أنه مشهور جداً، ولن يكون هذا آخر تعاون بيننا.",
      en: "We asked him to reach a target number of subscriptions within a week — it was reached within the first 10 hours. We thought he was famous, but he turned out to be very famous. This won't be our last collaboration.",
    },
    badge: { ar: "الهدف تحقق في 10 ساعات", en: "Goal Hit in 10 Hours" },
  },
  {
    id: "qadyk",
    client: { ar: "منصة قاضيك", en: "Qadyk Platform" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/quv89tef_IMG_5895.jpeg",
    text: {
      ar: "باسم منصة قاضيك نتقدّم بالشكر والتقدير للأستاذ عبدالرحمن على شراكته المميزة وتعاونه المهني والمثمر الذي انعكس على نتائج واضحة ونجاحات نعتز فيها.",
      en: "On behalf of Qadyk Platform, we extend our thanks and appreciation to Mr. Abdulrahman for his distinguished partnership and professional, fruitful cooperation, which reflected clear results and successes we are proud of.",
    },
    badge: { ar: "شراكة مميزة ونتائج واضحة", en: "Distinguished Partnership" },
  },
  {
    id: "dealup",
    client: { ar: "تطبيق Deal Up", en: "Deal Up App" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/19ns0mqq_IMG_5896.jpeg",
    text: {
      ar: "شكراً أستاذ عبدالرحمن الهادي على دعمك وإعلانك الجميل لتطبيقنا، ماشاء الله تبارك الله من بعد الإعلان علّق التطبيق بسبب كثرة التسجيل.",
      en: "Thank you, Mr. Abdulrahman Al-Hadi, for your support and the wonderful ad for our app. Mashallah, right after the ad the app crashed due to the sheer number of sign-ups.",
    },
    badge: { ar: "ضغط تسجيل هائل", en: "Massive Sign-up Surge" },
  },
  {
    id: "xiaomi",
    client: { ar: "شركة شاومي", en: "Xiaomi" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/4v5p1s6t_SIX_A49973AC-E7B8-4815-87F5-79978A8959D7.webp",
    text: {
      ar: "نحن سعداء بهذا التعاون مع الأستاذ عبدالرحمن الهادي، وكان فيديو الإعلان احترافياً وحقّق جميع أهدافنا بنجاح.",
      en: "We are delighted with this collaboration with Mr. Abdulrahman Al-Hadi. The ad video was professional and successfully achieved all of our goals.",
    },
    badge: { ar: "تحقيق كل الأهداف", en: "All Goals Achieved" },
  },
  {
    id: "lg",
    client: { ar: "شركة LG", en: "LG" },
    logo: "https://customer-assets.emergentagent.com/job_influencer-stats-hub-1/artifacts/pgdmmqk3_IMG_5929.jpeg",
    text: {
      ar: "أبدع الأستاذ عبدالرحمن الهادي في عمل تغطية لمنتجنا الجديد، ونشكره لأبعد حد على هذا الإعلان المميز.",
      en: "Mr. Abdulrahman Al-Hadi excelled in covering our new product. We thank him immensely for this outstanding ad.",
    },
    badge: { ar: "تغطية احترافية مميزة", en: "Standout Product Coverage" },
  },
];
